import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGridCrmUsers } from 'services/user-crm-profiles';
import { actionCrmUsersChangeItem, actionCrmUsersGetAllDynamic } from './actions';

interface Filters {
  search: string;
  userCrmProfilePermissionID: string;
  isActive: null | string | boolean;
}
interface Pagination {
  take: number;
  count: number;
  page: number;
}
interface OrderBy {
  field: string;
  order: 'desc' | 'asc' | null;
}

interface State {
  error: null | Error;
  isLoading: boolean;
  isInit: boolean;
  data: IGridCrmUsers[];
  filters: Filters;
  pagination: Pagination;
  orderBy: OrderBy;
}

export const defaultCrmUsersFilters = {
  search: '',
  userCrmProfilePermissionID: '',
  isActive: 'true',
};

const initState = (): State => {
  return {
    error: null,
    isLoading: false,
    isInit: false,
    data: [],
    filters: defaultCrmUsersFilters,
    pagination: {
      take: 25,
      count: 0,
      page: 1,
    },
    orderBy: {
      field: '',
      order: null,
    },
  };
};

const slice = createSlice({
  name: 'CRM_USERS',
  initialState: initState(),
  reducers: {
    actionCrmUsersRevalidateData(state) {
      state.isInit = false;
    },
    actionCrmUsersFiltersSet(state, action: PayloadAction<Partial<Filters>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    actionCrmUsersFiltersReset(state) {
      state.filters = initState().filters;
    },
    actionCrmUsersOrderBySet(state, action: PayloadAction<Partial<OrderBy>>) {
      state.orderBy = { ...state.orderBy, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actionCrmUsersGetAllDynamic.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.pagination.page = action.meta.arg?.page || state.pagination.page;
      state.pagination.take = action.meta.arg?.take || state.pagination.take;
    });
    builder.addCase(actionCrmUsersGetAllDynamic.fulfilled, (state, action) => {
      const {
        payload: { items, count },
      } = action;
      state.isLoading = false;
      state.isInit = true;
      state.data = items;
      state.pagination.count = count ?? 0;
    });
    builder.addCase(actionCrmUsersGetAllDynamic.rejected, (state, action) => {
      const { error } = action;
      state.isLoading = false;
      state.error = error as Error;
      state.isInit = true;
    });
    builder.addCase(actionCrmUsersChangeItem.fulfilled, (state) => {
      state.isInit = false;
    });
  },
});

export const {
  actionCrmUsersOrderBySet,
  actionCrmUsersFiltersSet,
  actionCrmUsersRevalidateData,
  actionCrmUsersFiltersReset,
} = slice.actions;
export const reducerCrmUsers = slice.reducer;
